import { m_getUrlKey } from './browser'

export const getPageName = () => {
  if (location.pathname.includes('/home')) {
    return 'edu_web_home_page'
  } else if (location.pathname.includes('/price')) {
    return 'edu_web_price_page'
  } else if (location.pathname.includes('/help')) {
    return 'edu_web_help_page'
  }
  return location.pathname
}

export const getFromPage = () => {
  const fromPage = m_getUrlKey('fromPage') || ''
  if (fromPage === 'home') {
    return 'edu_web_home_page'
  } else if (fromPage === 'price') {
    return 'edu_web_price_page'
  } else if (fromPage === 'help') {
    return 'edu_web_help_page'
  }
  return fromPage
}
